export default __webpack_public_path__ + "images/df372f11783b891019ed4a8584cd6089.png";